import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  postRequest (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'requests',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.updateFail)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getRequestOwner (id, lastet) {
    let sortType = lastet ? 'recentComments' : 'requestComments'
    return new Promise((resolve, reject) => {
      Axios.get(
        'requests/' + id + '?include=' + sortType,
        {},
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          resolve(response.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  likeRequest (params = {}, id) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'requests/' + id + '/request_goods',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.updateFail)
          }
          resolve(response.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  commentRequest (params = {}, id) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'requests/' + id + '/request_comments',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.updateFail)
          }
          resolve(response.data)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/requestservice.js